import * as yup from 'yup';

export const gameSchema = yup.object().shape({
  media: yup.mixed().required(),
  emoji: yup.string().required('Emoji obligatoire'),
  name: yup.string().required('Le nom est obligatoire'),
});
